export default {"src":"/planos/_next/static/media/page404Background.25711d47.svg","height":213,"width":288,"blurWidth":0,"blurHeight":0};